export const INIT_ACTION = 'init';

export const CHANGE_ORDER_ACTION = 'change_order_action';

export const OPEN_INPUT_ACTION = 'open_input';

export const CREATE_COMMENT_ACTION = 'create_comment';

export const COMPLAIN_ON_COMMENT_ACTION = 'complain_on_comment';

export const START_COMMENT_EDITING_ACTION = 'start_comment_editing';

export const UPDATE_COMMENT_ACTION = 'update_comment';

export const CANCEL_COMMENT_EDITING_ACTION = 'cancel_comment_editing';

export const DELETE_COMMENT_ACTION = 'delete_comment';

export const LIKE_COMMENT_ACTION = 'like_comment';

export const HIDE_MODAL_ACTION = 'hide_modal';

export const HIGHLIGHT_COMMENT_ACTION = 'highlight_comment';
